import { render, staticRenderFns } from "./GrantList.vue?vue&type=template&id=1aed1bd5&scoped=true&"
import script from "./GrantList.vue?vue&type=script&lang=js&"
export * from "./GrantList.vue?vue&type=script&lang=js&"
import style0 from "./GrantList.vue?vue&type=style&index=0&id=1aed1bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed1bd5",
  null
  
)

export default component.exports